module.exports = __webpack_public_path__ + "static/Artboard_6-6cb742b2f9858a11e4fde15c505bd40b.svg";